const SPACE = 32;
const ENTER = 13;

const KEY_CODES = {
  SPACE,
  ENTER,
};

export default KEY_CODES;
